// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3Amm4","content":"ManualTimeModal_content__3ZV_3"};